import { render, staticRenderFns } from "./saveTemplateModal.vue?vue&type=template&id=72f61643&"
import script from "./saveTemplateModal.vue?vue&type=script&lang=ts&"
export * from "./saveTemplateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports